<div class="bg-white rounded-[16px] border-[1px] border-solid border-[#DDE4EB] mt-[45px] grid grid-cols-1 md:grid-cols-3 gap-[0rem] md:gap-[1.5rem] ">
  <div class=" bg-[#FAFCFD] rounded-s-[16px] relative border-e-[1px] border-solid border-[#DDE4EB] py-[61px] px-[32px]">
    <div class="absolute top-[0] left-[50%] flex gap-[6px]" style="transform: translate(-50%, -50%);">
      @for (button of [1,2,3]; track $index) {
      <p-skeleton width="114px" height="44px" borderRadius="6px" styleClass=" button-shadow " />}
    </div>
    @for (item of [1,2,3,4,5,6,7,8,9]; track $index) {
    <div class="flex items-center mb-3">
      <p-skeleton shape="circle" size="1.5rem" styleClass="me-2" />
      <p-skeleton width="12rem" height="1rem" />
    </div>
    }
  </div>
  <div class="col-span-2 p-[32px] flex flex-col justify-between">
    <p-skeleton width="10rem" height="1rem" styleClass="mb-3" />
    <p-skeleton width="9rem" height="0.5rem" styleClass="mb-3" />

    <div class="border-b-[1px] border-solid border-[#DDE4EB] w-full mt-[24px] mb-[20px]"></div>

    <p-skeleton width="5rem" height="0.5rem" styleClass="mb-3" />
    <p-skeleton width="10rem" height="0.5rem" styleClass="mb-3" />

    <div class="grid grid-cols-1 md:grid-cols-3 gap-[12px]">
      @for (plan of [1,2,3]; track $index) {
      <div class="bg-[#F5F7FA] rounded-[12px] border-[1px] border-solid border-[#DDE4EB] p-3 w-full">
        <p-skeleton width="6rem" height="1rem" styleClass="mb-3" />


        <div class="flex items-end">
          <p-skeleton width="8rem" height="1.5rem" styleClass="mb-3" /> / <p-skeleton width="4rem" height="1rem"
            styleClass="mb-2" />
        </div>

        <p-skeleton width="5rem" height="0.5rem" styleClass="mb-3" />
        <p-skeleton width="7rem" height="0.5rem" styleClass="mb-4" />

        <div class="border-b-[1px] border-solid border-[#DDE4EB] w-full mt-[24px] mb-[20px]"></div>

        <p-skeleton width="100%" height="2.5rem" styleClass="mb-2" />
      </div>
      }
    </div>
  </div>
</div>
